import actions from "@/store/modules/organisations/organisation-approval-chain-templates/actions";
import {
  mutations,
  state
} from "@/store/modules/organisations/organisation-approval-chain-templates/mutations";

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
